/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" _fill="#27DBBD" d="M10 7.879l7.44-7.44a1.5 1.5 0 112.12 2.122L12.122 10l7.44 7.44a1.5 1.5 0 11-2.122 2.12L10 12.122l-7.44 7.44A1.5 1.5 0 11.44 17.44L7.878 10 .439 2.56A1.5 1.5 0 112.561.44L10 7.878z"/>'
  }
})
